import React from 'react';

/**
 * Slider component (improved for visibility).
 * Props: min, max, step, value, onChange, label, showValue (default true)
 */
export default function Slider({ min = 0, max = 100, step = 1, value, onChange, label, showValue = true }) {
  // Calculate percentage for filled track
  const percent = ((value - min) / (max - min)) * 100;

  return (
    <div className="w-full">
      {label && <label className="label mb-1">{label}</label>}
      <div className="flex items-center space-x-2">
        <div className="relative w-full h-3 flex items-center">
          {/* Track background */}
          <div className="absolute w-full h-2 rounded-full bg-gray-300" />
          {/* Filled track */}
          <div
            className="absolute h-2 rounded-full bg-primary"
            style={{ width: `${percent}%` }}
          />
          {/* Native input (transparent, but thumb is visible) */}
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={onChange}
            className="w-full h-3 bg-transparent appearance-none focus:outline-none"
            aria-valuenow={value}
            aria-valuemin={min}
            aria-valuemax={max}
            style={{ zIndex: 1 }}
          />
          {/* Custom thumb styling for Webkit browsers */}
          <style>{`
            input[type='range']::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              width: 1.25rem;
              height: 1.25rem;
              border-radius: 9999px;
              background: var(--hc-gradient-from, #ff616d);
              border: 2px solid #fff;
              box-shadow: 0 1px 4px rgba(0,0,0,0.12);
              cursor: pointer;
              transition: background 0.2s;
            }
            input[type='range']:focus::-webkit-slider-thumb {
              outline: 2px solid var(--hc-gradient-from, #ff616d);
              outline-offset: 2px;
            }
            input[type='range']::-moz-range-thumb {
              width: 1.25rem;
              height: 1.25rem;
              border-radius: 9999px;
              background: var(--hc-gradient-from, #ff616d);
              border: 2px solid #fff;
              box-shadow: 0 1px 4px rgba(0,0,0,0.12);
              cursor: pointer;
              transition: background 0.2s;
            }
            input[type='range']:focus::-moz-range-thumb {
              outline: 2px solid var(--hc-gradient-from, #ff616d);
              outline-offset: 2px;
            }
            input[type='range']::-ms-thumb {
              width: 1.25rem;
              height: 1.25rem;
              border-radius: 9999px;
              background: var(--hc-gradient-from, #ff616d);
              border: 2px solid #fff;
              box-shadow: 0 1px 4px rgba(0,0,0,0.12);
              cursor: pointer;
              transition: background 0.2s;
            }
            input[type='range']:focus::-ms-thumb {
              outline: 2px solid var(--hc-gradient-from, #ff616d);
              outline-offset: 2px;
            }
            input[type='range']::-ms-fill-lower {
              background: var(--hc-gradient-from, #ff616d);
              border-radius: 9999px;
            }
            input[type='range']::-ms-fill-upper {
              background: #e5e7eb;
              border-radius: 9999px;
            }
            input[type='range'] {
              outline: none;
            }
          `}</style>
        </div>
        {showValue && (
          <span className="text-sm font-medium w-12 text-right">{value}</span>
        )}
      </div>
    </div>
  );
} 